import React, {useEffect, useState} from 'react';
import {EffectIcon, ShuffleIcon} from "../assets/icons";
import {Switch, Checkbox} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {setColorType, setOutlineColour, setShadowColour, toggleTriggerPallet} from "../store/reducers/colorReducer";
import {setPanelKey} from "../store/reducers/panleKey";
import {OpacityMode, StyledSlider} from "./StyledComponents";
import {marks} from "../utils/constants";
import GradientManager from "../Layouts/SubPanels/GradientManager";
import {useDispatch, useSelector} from "react-redux";
import {styled} from "@mui/system";
import MuiInput from "@mui/material/Input";
import Stack from "@mui/joy/Stack";

const ColorProps = ({currentColor}) => {

    const Input = styled(MuiInput)`
  width: 42px;
`;

    const {canvas} = useSelector((state) => state.canvas);

    const {activeObject} = useSelector((state) => state.canvas);
    const {activeSetting} = useSelector((state) => state.canvas);
    const {shadowColor} = useSelector((state) => state.colorSlice);
    const {outlineColor} = useSelector((state) => state.colorSlice);
    const panelKey = useSelector((state) => state.panelKey).panelKey;
    const {colorType} = useSelector((state) => state.colorSlice);

    const [values, setValues] = useState(0);
    const [outlineSlider, setOutlineSlider] = useState(0);

    const [shadowAccordion, setShadowAccordion] = useState(false);
    const [gradientAccordion, setGradientAccordion] = useState(false);
    const [outlineAccordion, setOutlineAccordion] = useState(false);
    const [isShadow, setIsShadow] = useState(false);
    const [isGradient, setIsGradient] = useState(false);
    const [isOutline, setIsOutline] = useState(false);
    const [opacity, setOpacity] = React.useState(1);

    const dispatch = useDispatch();

    useEffect(() => {
        if (activeSetting) {
            const {
                shadow, strokeWidth, stroke, isShadow, isOutline, textGradient, opacity
            } = activeSetting;
            dispatch(setShadowColour(shadow?.color ? shadow?.color : '#FF0000'))
            setValues(shadow?.blur ? shadow?.blur : 0)
            dispatch(setOutlineColour(activeObject?.stroke ? activeObject.stroke : '#ff0000'))
            setOutlineSlider(strokeWidth * 100)
            setIsOutline(isOutline);
            setIsShadow(isShadow);
            if (!textGradient && activeObject) {
                if (typeof activeObject.fill === 'object') setIsGradient(true)
                else setIsGradient(false)
            } else if (textGradient && activeObject) {
                setIsGradient(textGradient)
            }
            setOpacity(opacity * 100)
        }
    }, [activeSetting, panelKey, currentColor]);


    const toggleShadow = (state) => {
        let shadow = {color: '#FF0000', offsetX: 0.9, offsetY: 0.9, blur: 0, id: 6};
        if (activeObject) {
            activeObject.set({isShadow: state})
            activeObject.set({shadow: state ? shadow : null})
            dispatch(setShadowColour(state ? shadow.color : '#000'))
            setValues(state ? shadow.blur : 0)
            setIsShadow(state)
            state && dispatch(setColorType('shadow'))
        }
        canvas.fire('object:modified', {target: activeObject});
        canvas.renderAll()
    }

    const toggleOutline = (state) => {
        if (activeObject) {
            activeObject.set({
                stroke: '#ff0000',
                strokeWidth: state ? .1 : 0,
                isOutline: state
            });
            dispatch(setOutlineColour('#ff0000'))
            setOutlineSlider(.1 * 100)
            setIsOutline(state)
            state && dispatch(setColorType('outline'))
        }
        canvas.fire('object:modified', {target: activeObject});
        canvas.renderAll()
    }

    const toggleEffect = (event, accordion) => {
        if (activeObject && activeObject.type === 'textbox') {
            switch (accordion) {
                case 'shadow' :
                    if (!shadowAccordion) setShadowAccordion(true)
                    toggleShadow(event.target.checked);
                    break;
                case 'outline':
                    if (!outlineAccordion) setOutlineAccordion(true)
                    toggleOutline(event.target.checked)
                    break;
                case 'gradient':
                    if (!gradientAccordion) setGradientAccordion(true)
                    if (activeObject) {
                        activeObject.set({
                            textGradient: event.target.checked
                        });
                    }
                    setIsGradient(event.target.checked)
                    event.target.checked && dispatch(setColorType('gradient'))
                    canvas.fire('object:modified', {target: activeObject});
                    break;
                default:
                    break
            }
        }
    };
    const toggleAccordion = (event, accordion) => {
        if (event.target.type === 'checkbox') return
        switch (accordion) {
            case 'shadow' :
                setShadowAccordion(!shadowAccordion)
                break;
            case 'outline':
                setOutlineAccordion(!outlineAccordion)
                break;
            case 'gradient':
                setGradientAccordion(!gradientAccordion)
                break;
            default:
                break
        }
    };

    const handleSliderChange = (event, accordion) => {
        const newValue = event.target.value === '' ? '' : Number(event.target.value);
        if (activeObject && activeObject.type === 'textbox') {
            switch (accordion) {
                case 'shadow' :
                    if (activeObject && activeObject.shadow) {
                        activeObject.shadow.blur = newValue
                        canvas.renderAll()
                    }
                    setValues(newValue);
                    setIsShadow(true)
                    break;
                case 'outline':
                    activeObject.set({
                        strokeWidth: newValue / 100
                    });
                    canvas.renderAll()
                    setOutlineSlider(newValue);
                    setIsOutline(true)
                    break;
                default:
                    break
            }
        }
    };

    const handleBlur = (accordion) => {
        if (activeObject && activeObject.type === 'textbox') {
            const value = values;
            let newValue = value;

            if (value < 0) {
                newValue = 0;
            } else if (value > 100) {
                newValue = 100;
            }
            switch (accordion) {
                case 'shadow' :
                    setValues(newValue);
                    break;
                case 'outline':
                    setOutlineSlider(newValue);
                    break;
                default:
                    break
            }
        }
    };

    const getRemixColor = () => {
        let allColors = [];

        // Generate random colors
        let fill = '#' + Math.floor(Math.random() * 16777215).toString(16);
        let shadow = '#' + Math.floor(Math.random() * 16777215).toString(16);
        let stroke = '#' + Math.floor(Math.random() * 16777215).toString(16);

        allColors.push(fill);
        if (isShadow) allColors.push(shadow);
        if (isOutline) allColors.push(stroke);

        return allColors;
    };

    function valuetext(value) {
        return value;
    }

    const handleOpacityChange = (event, value) => {
        const opacity = value / 100;
        if (activeObject) {
            activeObject.set({opacity: opacity});
            setOpacity(value)
            canvas.renderAll();
        }
    };
    const applyRemixColor = () => {
        if (!activeObject || activeObject.type !== 'textbox') return;

        let colors = getRemixColor();

        if (colors.length) {
            for (let i = colors.length - 1; i > 0; i--) {
                let j = Math.floor(Math.random() * (i + 1));
                let temp = colors[i];
                colors[i] = colors[j];
                colors[j] = temp;
            }
            activeObject.set('fill', colors.shift());
            if (isShadow) activeObject.shadow.color = colors.shift();
            if (isOutline) activeObject.set('stroke', colors.shift());
            canvas.renderAll();
        }
    };

    return (
        <div className='effect-wrapper'>
            <OpacityMode style={{width: '100%'}}>
                <span>Opacity</span>
                <StyledSlider
                    sx={{mt: 2}}
                    aria-label="Always visible"
                    value={opacity}
                    getAriaValueText={valuetext}
                    marks={marks}
                    onChange={handleOpacityChange}
                />
            </OpacityMode>
            {activeObject && activeObject.type === 'textbox' &&
                <>
                    <div className="remix-wrapper">
                        <div onClick={applyRemixColor} className="remix-btn d-flex-center">
                            <ShuffleIcon/>
                            <span className="name-heading">Remix styles</span>
                        </div>
                    </div>
                    <div className={`${colorType === 'text' ? 'active-color' : ''} effect-acordion`}>
                        <div className="d-flex-center">
                            <div className="color-picker accordion-icon" onClick={() => {
                                dispatch(setColorType('text'))
                                dispatch(setPanelKey('colorPicker'))
                                dispatch(toggleTriggerPallet(''))

                            }}>
                                <div className="color-input color-preview"
                                     style={{background: `${(typeof (activeObject?.fill) === 'object') ? '#000' : activeObject?.fill}`}}></div>
                            </div>
                            <span className="name-heading">Text</span>
                        </div>
                    </div>
                    <div className={`${colorType === 'gradient' ? 'active-color' : ''} effect-acordion`}
                         onClick={(e) => toggleAccordion(e, 'gradient')}>
                        <div className="d-flex-center">
                            <div className='accordion-icon bg-icon-image-gradient'></div>
                            <span className="name-heading">Linear Gradient</span>
                        </div>
                        <div className="d-flex-center">
                            <Switch checked={isGradient} onChange={(e) => toggleEffect(e, 'gradient')}
                                    inputProps={{'aria-label': 'controlled'}}/>
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    {gradientAccordion && <div className="expandable-accordion">
                        <GradientManager isGradient={isGradient}/>
                    </div>}

                    <div className={`${colorType === 'shadow' ? 'active-color' : ''} effect-acordion`}
                         onClick={(e) => toggleAccordion(e, 'shadow')}>
                        <div className="d-flex-center">
                            <div className='accordion-icon bg-icon-image-shadow'></div>
                            <span className="name-heading">Shadow</span>
                        </div>
                        <div className="d-flex-center">
                            <Switch checked={isShadow} onChange={(e) => toggleEffect(e, 'shadow')}
                                    inputProps={{'aria-label': 'controlled'}}/>
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    {shadowAccordion && <div className="expandable-accordion">
                        <Stack spacing={0.5}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Box>Color</Box>
                                <div className="color-picker" onClick={() => {
                                    dispatch(setColorType('shadow'))
                                    dispatch(setPanelKey('colorPicker'))
                                    dispatch(toggleTriggerPallet(''))
                                }}>
                                    <div className="color-input color-preview" style={{background: `${shadowColor}`}}></div>
                                </div>
                            </Stack>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs>
                                    <StyledSlider
                                        value={typeof values === 'number' ? values : 0}
                                        onChange={(e) => handleSliderChange(e, 'shadow')}
                                        aria-labelledby="input-slider"
                                        min={0}
                                        max={10}
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={values}
                                        size="small"
                                        onChange={(e) => handleSliderChange(e, 'shadow')}
                                        onBlur={(e) => handleBlur('shadow')}
                                        inputProps={{
                                            min: 0,
                                            max: 10,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </div>}

                    <div className={`${colorType === 'outline' ? 'active-color' : ''} effect-acordion`}
                         onClick={(e) => toggleAccordion(e, 'outline')}>
                        <div className="d-flex-center">
                            <div className='accordion-icon bg-icon-image-outline'></div>
                            <span className="name-heading">Outline</span>
                        </div>
                        <div className="d-flex-center">
                            <Switch checked={isOutline} onChange={(e) => toggleEffect(e, 'outline')}
                                    inputProps={{'aria-label': 'controlled'}}/>
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    {outlineAccordion && <div className="expandable-accordion">
                        <Stack spacing={0.5}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Box>Color</Box>
                                <div className="color-picker">
                                    <div className="color-picker" onClick={() => {
                                        dispatch(setColorType('outline'))
                                        dispatch(setPanelKey('colorPicker'))
                                        dispatch(toggleTriggerPallet(''))
                                    }}>
                                        <div className="color-input color-preview"
                                             style={{background: `${outlineColor}`}}></div>
                                    </div>
                                </div>
                            </Stack>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs>
                                    <StyledSlider
                                        value={typeof outlineSlider === 'number' ? outlineSlider : 0}
                                        onChange={(e) => handleSliderChange(e, 'outline')}
                                        aria-labelledby="input-slider"
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={outlineSlider}
                                        size="small"
                                        onChange={(e) => handleSliderChange(e, 'outline')}
                                        onBlur={(e) => handleBlur('outline')}
                                        inputProps={{
                                            min: 0,
                                            max: 100,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </div>
                    }
                </>
            }
        </div>

    )
}
export default ColorProps;